  (function () {
    document.querySelectorAll('.testimonial-section').forEach(function (section) {
      const thumbBtns = section.querySelectorAll('.testimonial-thumb-btn');
      const cardMedias = section.querySelectorAll('.testimonial-card-media');
      const contents = section.querySelectorAll('.testimonial-testimonial-content');
      const currentEl = section.querySelector('.testimonial-current-number');
      const totalEl = section.querySelector('.testimonial-total-number');
      const total = thumbBtns.length;

      if (!total) return;

      if (totalEl) totalEl.textContent = String(total).padStart(2, '0');

      let current = 0;
      let timer = null;
      const DELAY = 4000;

      function goTo(index) {
        thumbBtns[current].classList.remove('active');
        cardMedias[current].classList.remove('active');
        contents[current].classList.remove('active');

        current = (index + total) % total;

        thumbBtns[current].classList.add('active');
        cardMedias[current].classList.add('active');
        contents[current].classList.add('active');

        if (currentEl) currentEl.textContent = String(current + 1).padStart(2, '0');
      }

      function startAuto() {
        clearInterval(timer);
        timer = setInterval(function () {
          goTo(current + 1);
        }, DELAY);
      }

      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          goTo(parseInt(btn.dataset.index, 10));
          startAuto();
        });
      });

      startAuto();
    });
  })();